import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <h3>Kidopia 🌸</h3>

      <div className="footer-links">
        <Link to="/about">About</Link>
        <Link to="/privacy">Explore</Link>
        <Link to="/terms">faq</Link>
        <Link to="/contact">dashboard</Link>
      </div>

      <p className="footer-bottom">
        © 2026 Kidopia
      </p>
    </footer>
  );
};

export default Footer;